import { Controller } from "stimulus";

export default class extends Controller {
  static targets = [
    "statusFilter",
    "tableRow",
    "statusSelect"
  ]

  connect() {}

  filter() {
    const selectedStatus = this.hasStatusFilterTarget ? this.statusFilterTarget.value : "";
    const showAll = selectedStatus === "" || selectedStatus === null;

    this.tableRowTargets.forEach(row => {
      const rowStatus = row.dataset.status || "";

      if (showAll || rowStatus === selectedStatus) {
        row.style.display = "";
      } else {
        row.style.display = "none";
      }
    });
  }

  statusChanged(event) {
    const select = event.target
    const enrollmentId = select.dataset.enrollmentId
    const newStatus = select.value

    if (!enrollmentId) return

    const row = select.closest("tr")
    const previousStatus = row?.dataset.status

    if (row) row.dataset.status = newStatus

    fetch(`/schools/reports/student-programs/${enrollmentId}`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
        "X-CSRF-Token": this.csrfToken
      },
      body: JSON.stringify({ enrollment: { status: newStatus } })
    })
      .then(response => {
        if (!response.ok) throw new Error("Failed to update status")
        return response.json()
      })
      .then(data => {
        if (row && data.status) {
          row.dataset.status = data.status
          select.value = data.status
        }
        this.showToast("Status changed")
      })
      .catch(error => {
        console.error(error)
        if (row && previousStatus) {
          row.dataset.status = previousStatus
          select.value = previousStatus
        }
        this.showToast("Could not update status")
      })
  }

  get csrfToken() {
    const meta = document.querySelector('meta[name="csrf-token"]')
    return meta && meta.content
  }

  showToast(message) {
    window.dispatchEvent(new CustomEvent("toast:show", {
      detail: { message }
    }));
  }

  async showCopyQuickLook(event) {
    event.preventDefault();

    const enrollmentId = event.currentTarget.dataset.enrollmentId;

    if (!enrollmentId) {
      console.error("Enrollment ID not found");
      return;
    }

    const csrfToken = document.querySelector('meta[name="csrf-token"]').content;

    const response = await fetch(`/schools/reports/student-programs/copy-quick-look/${enrollmentId}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        "X-CSRF-Token": csrfToken,
        "Accept": "text/vnd.turbo-stream.html"
      }
    });

    if (response.ok) {
      const quickViewElement = document.querySelector("#student-program-copy-quick-look");
      
      if (!quickViewElement) {
        console.error("Quick view element not found in the DOM.");
        return;
      }

      quickViewElement.classList.remove("u-hidden");

      const responseBody = await response.text();
      Turbo.renderStreamMessage(responseBody);
    } else {
      console.error("Failed to load quick look:", response.statusText);
    }
  }

  closeCopyQuickLook(event) {
    event.preventDefault();
    const quickViewElement = document.querySelector("#student-program-copy-quick-look");
    if (quickViewElement) {
      quickViewElement.classList.add("u-hidden");
    }
  }
}

